(function () {
	const header = () => {
		const body = document.querySelector("body");
		const header = document.querySelector(".shopify-section-header");
		const openBtn = document.querySelector(".header__offcanvas-toggle");
		const closeBtn = document.querySelector(
			".header__offcanvas-toggle-link--close",
		);
		const offMenu = document.querySelector(".header__offcanvas-menu");
		const searchDetails = document.querySelector(".header__details");
		const submenuDetails = document.querySelectorAll(
			".header__submenu li details",
		);
		const openSearchBtn = document.querySelector(".header__search");
		const headerIsAlwaysSticky =
			header
				.querySelector(".header-wrapper")
				.getAttribute("data-sticky-type") === "always";
		const headerIsSticky =
			header
				.querySelector(".header-wrapper")
				.getAttribute("data-sticky-type") === "on-scroll-up";
		const megaMenuLinks = document.querySelectorAll(".list-menu--megamenu");

		const openMenu = (e) => {
			e.preventDefault();
			offMenu.classList.add("header__offcanvas-menu--open");
			openBtn.classList.add("active");
			body.classList.add("body--hidden");
		};

		const closeMenu = () => {
			offMenu.classList.remove("header__offcanvas-menu--open");
			openBtn.classList.remove("active");
			body.classList.remove("body--hidden");
		};

		openBtn.addEventListener("click", openMenu);
		closeBtn.addEventListener("click", function (e) {
			e.preventDefault();
			closeMenu();
		});

		submenuDetails.forEach((targetDetail) => {
			targetDetail.addEventListener("click", () => {
				submenuDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute("open");
					}
				});
			});
		});

		document.addEventListener("keyup", (e) => {
			let scrollTop = window.scrollY;
			if (e.key === "Escape") {
				closeMenu();
				body.classList.remove("overflow-hidden");
				if (
					searchDetails.open &&
					scrollTop < header.offsetHeight / 2 &&
					headerIsSticky
				) {
					header.classList.remove(
						"animate",
						"animated",
						"shopify-section-header-sticky",
					);
					searchDetails.removeAttribute("open");
				} else if (
					searchDetails.open &&
					scrollTop < header.offsetHeight / 2 &&
					headerIsAlwaysSticky
				) {
					header.classList.remove("animate", "animated");
					header.classList.add("shopify-section-header-sticky");
					searchDetails.removeAttribute("open");
				} else if (
					searchDetails.open &&
					scrollTop > header.offsetHeight / 2 &&
					(headerIsSticky || headerIsAlwaysSticky)
				) {
					header.classList.add(
						"shopify-section-header-sticky",
						"fixed",
						"animate",
						"animated",
					);
					searchDetails.removeAttribute("open");
				} else if (
					searchDetails.open &&
					!headerIsAlwaysSticky &&
					!headerIsSticky
				) {
					header.classList.remove(
						"shopify-section-header-sticky",
						"fixed",
						"animate",
						"animated",
					);
					searchDetails.removeAttribute("open");
				}
			}
		});

		openSearchBtn.addEventListener("click", () => {
			let scrollTop = window.scrollY;
			if (searchDetails.open && headerIsAlwaysSticky) {
				body.classList.add("overflow-hidden");
				header.classList.add(
					"shopify-section-header-sticky",
					"fixed",
					"animate",
				);
			} else if (searchDetails.open && !headerIsAlwaysSticky) {
				body.classList.add("overflow-hidden");
				header.classList.add("shopify-section-header-sticky", "animate");
			} else if (
				!searchDetails.open &&
				scrollTop < header.offsetHeight / 2 &&
				headerIsSticky
			) {
				body.classList.remove("overflow-hidden");
				header.classList.remove(
					"animate",
					"animated",
					"shopify-section-header-sticky",
				);
			} else if (
				!searchDetails.open &&
				scrollTop < header.offsetHeight / 2 &&
				headerIsAlwaysSticky
			) {
				body.classList.remove("overflow-hidden");
				header.classList.remove("animate", "animated");
			} else if (
				!searchDetails.open &&
				scrollTop > header.offsetHeight / 2 &&
				(headerIsSticky || headerIsAlwaysSticky)
			) {
				body.classList.remove("overflow-hidden");
				header.classList.add(
					"shopify-section-header-sticky",
					"fixed",
					"animate",
					"animated",
				);
			} else if (
				!searchDetails.open &&
				!headerIsAlwaysSticky &&
				!headerIsSticky
			) {
				body.classList.remove("overflow-hidden");
				header.classList.remove(
					"shopify-section-header-sticky",
					"fixed",
					"animate",
					"animated",
				);
			} else {
				body.classList.remove("overflow-hidden");
				header.classList.remove(
					"shopify-section-header-sticky",
					"fixed",
					"animate",
					"animated",
				);
			}
		});

		document.addEventListener("scroll", () => {
			let scrollTop = window.scrollY;

			if (scrollTop > header.offsetHeight / 2 && headerIsAlwaysSticky) {
				header.classList.add("fixed", "animate");
			} else if (scrollTop <= header.offsetHeight && headerIsAlwaysSticky) {
				header.classList.remove("fixed", "animate");
			}
		});

		let scrollTop = window.scrollY;

		if (scrollTop > header.offsetHeight / 2 && headerIsAlwaysSticky) {
			header.classList.add("fixed", "animate");
		} else if (scrollTop <= header.offsetHeight && headerIsAlwaysSticky) {
			header.classList.remove("fixed", "animate");
		}

		megaMenuLinks.forEach((link) => {
			link.addEventListener("mouseenter", () => {
				link.classList.add("list-menu--megamenu-visible");
                document.body.classList.add("megamenu-visibled");              
				link.addEventListener("mousemove", () => {
					link.classList.add("list-menu--megamenu-visible");
                    document.body.classList.add("megamenu-visibled");
				});

				link.addEventListener("mouseleave", () => {
					setTimeout(() => {
						link.classList.remove("list-menu--megamenu-visible");
                        document.body.classList.remove("megamenu-visibled");
					}, 300);
					link.addEventListener("mouseenter", () => {
						link.classList.add("list-menu--megamenu-visible");
                        document.body.classList.add("megamenu-visibled");
					});
				});
			});
		});
	};

	document.addEventListener("shopify:section:load", header);

	header();
})();
